import { createContext, useContext } from "react";
import { MIN_RECIPIENTS } from "campaign-builder/channels/directmail/adm/adm.config";

export interface TargetingValidationApi {
  version: number;
}

export const TargetingValidationContext = createContext<TargetingValidationApi>({ version: 0 });

export const useTargetingValidation = () => useContext(TargetingValidationContext);

export { MIN_RECIPIENTS };
export { validateCampaignName, normalizeCampaignName } from "campaign-builder/state";

export const MIN_RECIPIENTS_MESSAGE = `Your selected audiences must total at least ${MIN_RECIPIENTS.toLocaleString(
  "en-US"
)} recipients.`;
